export default "__VITE_PUBLIC_ASSET__8219f02e__"